/**
 * Loading spinner component for session restoration
 * Displays a centered loading spinner with optional message
 */


interface LoadingSpinnerProps {
  message?: string
  className?: string
}

/**
 * Loading spinner component with customizable message
 * Used during session restoration and authentication processes
 * 
 * @param message - Optional loading message to display
 * @param className - Optional CSS classes for styling
 * @returns React component displaying loading spinner
 */
export default function LoadingSpinner({ 
  message = 'Loading...', 
  className = '' 
}: LoadingSpinnerProps) {
  return (
    <div className={`min-h-screen flex items-center justify-center bg-background ${className}`}>
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">{message}</p>
      </div>
    </div>
  )
}